<script setup lang="ts">
import {
	MenubarRoot,
	type MenubarRootEmits,
	type MenubarRootProps,
	useForwardPropsEmits,
} from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	MenubarRootProps & { class?: HTMLAttributes["class"] }
>();
const emits = defineEmits<MenubarRootEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<MenubarRoot
		v-bind="forwarded"
		:class="twMerge(
			'flex h-10 items-center gap-x-1 rounded-md border bg-background p-1',
			props.class,
		)"
	>
		<slot />
	</MenubarRoot>
</template>
